import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  AuraLayout,
  CashIcon,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { KapitalIcon } from "lola-framework-ui-test/src/icons";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { useStore } from "../../store/globalState";
import { formatLabeledAmount } from "../../utils";

type SendingFlavor = "a" | "b";

/**
 * Gallery-safe m2m sending chrome. Flavor A: CircularProgress + CashIcon.
 * Flavor B: KapitalIcon spin. No create-operation.
 */
export const SendingMoneyPage = memo(
  ({ flavor = "a" }: { flavor?: SendingFlavor }) => {
    const { t } = useTranslation("m2m");
    const { theme, amountState, quoteState } = useStore();
    const colorConfig = theme.whiteView;
    const { dropzoneColors, backgroundBtn, textColorBtn, title } = colorConfig;
    const displayAmount =
      (quoteState?.sendAmount ?? parseFloat(amountState.amount || "0")) || 0;
    const displayCurrency = quoteState?.sourceCurrency ?? "USD";
    const flavorClass = flavor === "b" ? "flavor-b" : "flavor-a";

    const content =
      flavor === "b" ? (
        <section className="sending-money-container">
          <KapitalIcon
            size={120}
            colors={dropzoneColors}
            className="animate-spin bg-transparent"
          />
          <section className="sending-caption">
            <PageTitle
              highlight={t("transfer.transferring", {
                defaultValue: "Transferring",
              })}
              highlightColor={title}
              secudnary={formatLabeledAmount(displayAmount, displayCurrency)}
              secudnaryColor={title}
            />
          </section>
        </section>
      ) : (
        <section className="sending-money-container">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundBtn}
          >
            <CashIcon size={60} colors={[textColorBtn, textColorBtn]} />
          </FlowHeroMark>
          <section className="sending-caption">
            <h1 className="foreground highlight text-centered">
              {t("transfer.transferring", { defaultValue: "Transferring" })}
              <span className="span-block lola-title-h1 h1">
                {formatLabeledAmount(displayAmount, displayCurrency)}
              </span>
            </h1>
          </section>
        </section>
      );

    return (
      <AuraLayout
        colorConfig={colorConfig}
        className={`white-view-background ${flavorClass}`}
      >
        <Layout.Content
          className={
            flavor === "b"
              ? "loading-section sending-money-section content-center"
              : "loading-section sending-money-section"
          }
        >
          {content}
        </Layout.Content>
      </AuraLayout>
    );
  },
);

export const SendingMoneyFlavorAPage = () => <SendingMoneyPage flavor="a" />;
export const SendingMoneyFlavorBPage = () => <SendingMoneyPage flavor="b" />;
